"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var moment_1 = __importDefault(require("moment"));
var styles = __importStar(require("./DatePicker.module.css"));
var DatePicker = (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.pdf = false;
        _this.pdf = window.isPdf;
        _this.enterKeyEvent = _this.enterKeyEvent.bind(_this);
        _this.changeFocus = _this.changeFocus.bind(_this);
        return _this;
    }
    DatePicker.prototype.changeFocus = function (nextInputId) {
        var nextInputRef = document.getElementById(nextInputId);
        if (nextInputRef) {
            nextInputRef.focus();
        }
    };
    DatePicker.prototype.enterKeyEvent = function (event) {
        if (event.key == "Enter" && this.props.nextInputId) {
            this.changeFocus(this.props.nextInputId);
        }
    };
    DatePicker.prototype.render = function () {
        var _a = this.props, json_data = _a.json_data, id = _a.id, onChange = _a.onChange, _b = _a.errors, errors = _b === void 0 ? {} : _b, classNameWrap = _a.classNameWrap, _c = _a.disabled, disabled = _c === void 0 ? false : _c, className = _a.className, dateParams = _a.dateParams, inputName = _a.inputName;
        var jsonId = inputName ? inputName : id;
        var value = json_data[jsonId] || "";
        var error = errors[jsonId];
        var classRoot = styles.root + " " + (error && styles.rootError) + " " + className + " " + classNameWrap;
        if (this.pdf) {
            if (json_data[jsonId]) {
                if (typeof json_data[jsonId] === "string" && json_data[jsonId].includes("T")) {
                    var parseDate = json_data[jsonId].split("T");
                    value = moment_1.default(parseDate[0] + "T00:00:00.000-00:00").format("MM/DD/YYYY");
                }
            }
        }
        var convertValue = value;
        if (!convertValue)
            convertValue = undefined;
        return (React.createElement("div", { className: classNameWrap + " DatePicker_wrapper" },
            React.createElement(react_datepicker_1.default, __assign({ id: id, selected: Date.parse(convertValue), onChange: function (date) {
                    onChange(jsonId, date);
                }, name: jsonId, className: classRoot, readOnly: disabled, onKeyDown: this.enterKeyEvent }, dateParams)),
            error && React.createElement("p", { className: styles.error },
                error,
                " ")));
    };
    return DatePicker;
}(React.Component));
exports.DatePicker = DatePicker;
//# sourceMappingURL=data:application/json;base64,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